import React from 'react';

interface DetectionIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const DetectionIcon = ({ size = 20, ...props }: DetectionIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00068 0C12.4122 0 16.0014 3.58918 16.0014 8.00068C16.0014 9.84648 15.3669 11.5435 14.3129 12.8987L20 18.5858L18.5858 20L12.8987 14.3129C11.5435 15.3669 9.84648 16.0014 8.00068 16.0014C3.58918 16.0014 0 12.4122 0 8.00068C0 3.58918 3.58918 0 8.00068 0ZM8.00068 2.00017C4.69181 2.00017 2.00017 4.69181 2.00017 8.00068C2.00017 11.3096 4.69181 14.0012 8.00068 14.0012C11.3096 14.0012 14.0012 11.3096 14.0012 8.00068C14.0012 4.69181 11.3096 2.00017 8.00068 2.00017ZM8.00068 9.50081C8.82918 9.50081 9.50081 10.1724 9.50081 11.0009C9.50081 11.8294 8.82918 12.5011 8.00068 12.5011C7.17219 12.5011 6.50056 11.8294 6.50056 11.0009C6.50056 10.1724 7.17219 9.50081 8.00068 9.50081ZM9.00077 3.00026V8.00068H7.0006V3.00026H9.00077Z"
        fill="currentColor"
      />
    </svg>
  );
};
